export const indefiniteArticle = (string: string) =>
  /^[aeiou]/i.test(string) ? 'an' : 'a'
